<template>
    <div v-if="videosData.length" :style="{ width: (tableWidth - 120)+'px', height: '20px', display:'inline-flex'}">
        <th v-for="(video, id) in videosData" :key="id" class="abc"
            :class="[video ? 'def' : '']" 
            style="text-align: center;"  
            :style="{ width: widthList[id] + 'px' }">
            <a href="javascript:" v-if="video && displayType === dateMode && filterTypeActive !== dateMode" @click="onShowPage('video-slider', id)"><img style="width:15px; height:15px" src="/common/img/icon-video.png" /></a>
            <img v-else-if="video" style="width:15px; height:15px" src="/common/img/icon-video.png" />
        </th>
    </div>
</template>

<script>
  import moment from 'moment'
  import { BButton} from 'bootstrap-vue'
  import { mapState } from 'vuex'
  moment.suppressDeprecationWarnings = true
  const today = moment().format('YYYY/MM/DD')
  export default {
    directives: {BButton},
    components: {
      BButton
    },
    data () {
      return {
        dateEnd: today,
        dateMode: 0
      }
    },
    props: {
      videosData: Array,
      widthList: Array,
      displayType: Number,
      dateFrom: String,
      filterTypeActive: Number,
      tableWidth: Number
    },
    computed: {
      ...mapState({
        seizures: state => state.patient.seizures,
        otpAccessToken: state => state.otp.otpAccessToken,
      })
    },
    methods: {
      async onShowPage(page, id) {
        if (this.$store.state.auth.typeOfUser !== 'pharmacy') {
          let labels = [];
          for (var m = moment(this.dateFrom); m.diff(this.dateEnd, 'days') <= 0; m.add(1, 'days')) {
              const date = m.format('YYYY/MM/DD')
              labels.push(date)
          }
          this.$emit('setLoading', true)
          if(this.$route.params.childId) {
            await this.$store.dispatch("patient/getVideosByChildId", {params: {
              from_date: labels[id],
              to_date: labels[id],
              childId: this.$route.params.childId
            }})
          }
          else {
            await this.$store.dispatch("patient/getVideos", { params: {
              one_time_access_key: this.otpAccessToken,
              from_date: labels[id],
              to_date: labels[id]
            }})
          }
          this.$emit('setLoading', false)
          this.$emit('dataVideo', {page: page, date: labels[id]})
        }
      }
    }
  }
</script>

<style>
  .video-js {
    width: 100%;
  }
  .vjs-big-play-button {
    display: none !important;
  }
  .video-js.vjs-ended .vjs-big-play-button {
      display: none !important;
  }
</style>